import React, { useState, useEffect, useCallback } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { useGlobalState } from 'resources/GlobalStateContext';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import Swal from 'sweetalert2';
import AsyncSelectTextField from 'components/Input/AsyncSelectTextField';

const Asignacion = ({ match }) => {
    const { id } = match.params;
    const { setGlobalTitulo } = useGlobalState();
    const [isOpenModal, openModal, closeModal] = useModal(false);
    let [categoria, setCategoria] = useState({});
    let [categoriaPadre, setCategoriaPadre] = useState(undefined);
    let [categoriaAsignar, setCategoriaAsignar] = useState({});

    const getCategoria = useCallback(() => {
        fetchConToken(`categorias?id=${id}&sucursal_Id=${getDataSession('sucursal')}`).then((cat) => {
            setCategoria(cat);
            fetchConToken(`categorias/GetAsignados?id=${id}&sucursal_Id=${getDataSession('sucursal')}`).then((categorias) => {
                setCategoriaPadre(undefined);
                if (categorias && categorias?.length > 0) {
                    var temp = categorias.find(x => x.sucursal_Id === getDataSession('sucursalPrincipal'));
                    if (temp) setCategoriaPadre(temp);
                }
            });
        });
    }, [id]);

    function asignar() {
        setCategoriaAsignar({});
        openModal();
    }

    function asignarCategoria() {
        if (categoriaAsignar && categoriaAsignar?.id > 0) Swal.fire({
            title: `¿Desea relacionar la categoria ${categoria?.nombre} con la categoria ${categoriaAsignar?.nombre}?`,
            showCancelButton: true,
            confirmButtonText: 'Relacionar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                var asignacion = {
                    sucursalOrg: getDataSession('sucursal'),
                    sucursalDes: getDataSession('sucursalPrincipal'),
                    catalogoOrg: categoria.id,
                    catalogoDes: categoriaAsignar.id
                };
                fetchConToken(`categorias/AsignarCategoria`, asignacion, 'PUT').then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }

                    Swal.fire('Asignación completa', 'Categoria Relacionado', 'success');
                    getCategoria();
                    setCategoriaAsignar({});
                    closeModal();
                });
            }
        });
    }

    function desvincular() {
        if (categoriaPadre) {
            Swal.fire({
                title: `¿Desea desvincular la categoria ${categoria?.nombre} de la categoria ${categoriaPadre?.nombre}?`,
                showCancelButton: true,
                confirmButtonText: 'Desvincular',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    var desvincular = {
                        sucursalOrg: getDataSession('sucursal'),
                        sucursalDes: getDataSession('sucursalPrincipal'),
                        catalogoOrg: categoria.id,
                        catalogoDes: categoriaPadre.id
                    };
                    fetchConToken(`categorias/DesvincularCategoria`, desvincular, 'PUT').then((response) => {
                        if (response.hasOwnProperty('status')) {
                            Object.entries(response?.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
                            return false;
                        } else if (response.hasOwnProperty('codigo')) {
                            Swal.fire('Error', response.mensajes[0], 'error');
                            return false;
                        }

                        Swal.fire('Exito', 'Categoria Desvinculado', 'success');
                        getCategoria();
                    })
                }
            });
        }
    }

    useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Asignacion de categorias',
            subtitulo: 'Aqui puede vincular las categorias de su tienda con la conexion principal'
        }));
        getCategoria();
    }, [setGlobalTitulo, getCategoria]);

    return (<>
        <div className='container-fluid'>
            <div className='col-md-12 text-right'>
                <Link to={'..'} className='btn btn-outline-warning'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='15'
                        height='15'
                        fill='currentColor'
                        className='bi bi-reply'
                        viewBox='0 0 16 16'
                    >
                        <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                    </svg>
                    &nbsp; Regresar
                </Link>
            </div>
            <div className='col-md-12'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center' colSpan={3}><h3>Categoria Conexión</h3></TableCell>
                                <TableCell align='center' colSpan={1} />
                                <TableCell align='center' colSpan={3}><h3>Categoria Conexión Principal</h3></TableCell>
                                <TableCell align='center' colSpan={1} />
                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'>Clave Categoria</TableCell>
                                <TableCell align='center'>Clave Categoria Padre</TableCell>
                                <TableCell align='center'>Nombre</TableCell>
                                <TableCell align='center' />
                                <TableCell align='center'>Clave Categoria</TableCell>
                                <TableCell align='center'>Clave Categoria Padre</TableCell>
                                <TableCell align='center'>Nombre</TableCell>
                                <TableCell align='center' />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell align='center'>{categoria.clave_Categoria}</TableCell>
                                <TableCell align='center'>{categoria.clave_Categoria_Padre}</TableCell>
                                <TableCell align='left'>{categoria?.nombre}</TableCell>
                                <TableCell align='center' />
                                <TableCell align='center'>{categoriaPadre?.clave_Categoria}</TableCell>
                                <TableCell align='center'>{categoriaPadre?.clave_Categoria_Padre}</TableCell>
                                <TableCell align='left'>{categoriaPadre?.nombre}</TableCell>
                                <TableCell align='right'>
                                    <Button variant='contained' onClick={() => asignar()}>Asignar</Button>&nbsp;
                                    <Button variant='contained' onClick={() => desvincular()} disabled={!categoriaPadre}>Desvincular</Button>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
        <Modal isOpen={isOpenModal} closeModal={closeModal}>
            <div className='card text-left' style={{ padding: 10 }}>
                <div className='container'>
                    <div>
                        <div className='espacio15px'></div>
                        <div className='card-title row  '>
                            <div className='col-md-6 text-left'><h3><label>&nbsp;Seleccione la categoria a relacionar</label></h3></div>
                            <div className='col-md-6 text-right'>
                                <Button variant='contained' onClick={() => asignarCategoria()}>
                                    Asignar
                                </Button>&nbsp;&nbsp;&nbsp;
                            </div>
                        </div>
                        <div className='espacio15px'></div>
                        {isOpenModal && <div className='card-body ' style={{ height: '50vh' }}>
                            <AsyncSelectTextField
                                getOptionLabel={(option) => option.id + ' - ' + option.nombre}
                                getOptionValue={(option) => option.id}
                                valueSelectTo={categoriaAsignar}
                                setValueSelectTo={setCategoriaAsignar}
                                url={`categorias/GetList?sucursal_Id=${getDataSession('sucursalPrincipal')}&paginas=1&totalXpagina=100`}
                            />
                        </div>}
                    </div>
                </div>
            </div>
        </Modal>
    </>);
};

export { Asignacion };